module.exports = __webpack_public_path__ + "static/media/ic_back.9cb33150.svg";